import {WidgetRestService} from './restServices';
import storageService from '../storageService';
import utilsService from '../utilsService';

var service = {};

service.getWidgetDtoByWidgetId = (
  widgetId,
  successCallbackFunction,
  failCallbackFunction,
) => {
  WidgetRestService.get(
    {
      endpoint: 'widgetId',
      endpointParam: widgetId,
      token: storageService.getItem('token'),
    },
    {},
    function (resource) {
      // success
      if (successCallbackFunction) {
        successCallbackFunction(resource);
      }
    },
    function (response) {
      if (failCallbackFunction) {
        failCallbackFunction(response);
      }
    },
  );
};
service.getWidgetIdByObjectIdAndWidgetType = (
  requestObject,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  requestObject.endpoint = 'widgetId';
  requestObject.endpointParam = 'byObjectIdAndWidgetType';
  requestObject.token = token ? token : storageService.getItem('token');

  WidgetRestService.get(
    requestObject,
    {},

    (resource) => {
      // success
      if (successCallbackFunction) {
        successCallbackFunction(resource.widgetId);
      }
    },
    function (response) {
      if (failCallbackFunction) {
        failCallbackFunction(response);
      }
    },
  );
};
service.getWidgetDtoBySessionTemplateId = (
  sessionInstanceId,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  const requestObject = {};
  requestObject.endpoint = 'sessionTemplateId';
  requestObject.endpointParam = sessionInstanceId;
  requestObject.token = token ? token : storageService.getItem('token');

  WidgetRestService.get(
    requestObject,
    {},

    (resource) => {
      // success
      if (successCallbackFunction) {
        successCallbackFunction(resource);
      }
    },
    function (response) {
      if (failCallbackFunction) {
        failCallbackFunction(response);
      }
    },
  );
};
service.getWidgetDtoByMentorId = (
  mentorId,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  const requestObject = {};
  requestObject.endpoint = 'mentorId';
  requestObject.endpointParam = mentorId;
  requestObject.token = token ? token : storageService.getItem('token');

  WidgetRestService.get(
    requestObject,
    {},

    (resource) => {
      // success
      if (successCallbackFunction) {
        successCallbackFunction(resource.widgetDto);
      }
    },
    function (response) {
      if (failCallbackFunction) {
        failCallbackFunction(response);
      }
    },
  );
};
service.getWidgetDtoByPersonalProfileName = (
  profileName,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  const requestObject = {};
  requestObject.endpoint = 'mentorProfileName';
  requestObject.endpointParam = encodeURI(profileName);

  requestObject.token = token ? token : storageService.getItem('token');

  WidgetRestService.get(
    requestObject,
    {},

    (resource) => {
      // success
      if (successCallbackFunction) {
        successCallbackFunction(resource);
      }
    },
    function (response) {
      if (failCallbackFunction) {
        failCallbackFunction(response);
      }
    },
  );
};
service.getWidgetDtosByAccountId = (
  accountId,
  successCallbackFunction,
  failCallbackFunction,
  token,
) => {
  WidgetRestService.get(
    {
      endpoint: 'accountId',
      endpointParam: accountId,
      token: token ? token : storageService.getItem('token'),
    },
    {},
    (resource) => {
      if (successCallbackFunction) {
        successCallbackFunction(resource);
      }
    },
    (response) => {
      if (failCallbackFunction) {
        failCallbackFunction(response.data);
      }
    },
  );
};

service.createWidgetByAccountId = (
  requestObject,
  successCallbackFunction,
  failCallbackFunction,
) => {
  const requestObj = {
    ...requestObject,
    token: storageService.getItem('token'),
  };
  WidgetRestService.save(
    {
      endpoint: 'create',
      endpoint2: 'usersAndAccount',
    },
    requestObj,
    (response) => {
      if (successCallbackFunction) {
        successCallbackFunction(response);
      }
    },
    (error) => {
      if (failCallbackFunction) {
        failCallbackFunction(error);
      }
    },
  );
};

service.createMentorsOnWidget = (
  requestObject,
  successCallbackFunction,
  failCallbackFunction,
) => {
  const requestObj = {
    ...requestObject,
    token: storageService.getItem('token'),
  };
  WidgetRestService.update(
    {
      endpoint: 'widget',
      endpoint2: 'mentor',
    },
    requestObj,
    (response) => {
      if (successCallbackFunction) {
        successCallbackFunction(response);
      }
    },
    (error) => {
      if (failCallbackFunction) {
        failCallbackFunction(error);
      }
    },
  );
};

service.moveMentorToWidget = (
  requestObject,
  successCallbackFunction,
  failCallbackFunction,
) => {
  const requestObj = {
    ...requestObject,
    token: storageService.getItem('token'),
  };
  WidgetRestService.update(
    {
      endpoint: 'move',
      endpoint2: 'mentor',
    },
    requestObj,
    (response) => {
      if (successCallbackFunction) {
        successCallbackFunction(response);
      }
    },
    (error) => {
      if (failCallbackFunction) {
        failCallbackFunction(error);
      }
    },
  );
};

service.cloneMentorOnWidget = (
  requestObject,
  successCallbackFunction,
  failCallbackFunction,
) => {
  const requestObj = {
    ...requestObject,
    token: storageService.getItem('token'),
  };
  WidgetRestService.update(
    {
      endpoint: 'clone',
      endpoint2: 'mentor',
    },
    requestObj,
    (response) => {
      if (successCallbackFunction) {
        successCallbackFunction(response);
      }
    },
    (error) => {
      if (failCallbackFunction) {
        failCallbackFunction(error);
      }
    },
  );
};

service.updateWidgetByWidgetId = (
  widgetId,
  widgetDto,
  successCallbackFunction,
  failCallbackFunction,
) => {
  utilsService.stringifyWidgetStyles(widgetDto);
  const requestObj = {
    widgetDto,
    token: storageService.getItem('token'),
  };
  WidgetRestService.update(
    {
      endpoint: 'save',
      endpointParam: widgetId,
    },
    requestObj,
    (response) => {
      if (successCallbackFunction) {
        successCallbackFunction(response);
      }
    },
    (error) => {
      if (failCallbackFunction) {
        failCallbackFunction(error);
      }
    },
  );
};

service.updateWidgetInteractionMode = (
  widgetId,
  widgetInteractionMode,
  successCallbackFunction,
  failCallbackFunction,
) => {
  const requestObj = {
    widgetId,
    newInteractionMode: widgetInteractionMode,
    token: storageService.getItem('token'),
  };
  WidgetRestService.update(
    {
      endpoint: 'interaction',
      endpointParam: widgetId,
    },
    requestObj,
    (response) => {
      if (successCallbackFunction) {
        successCallbackFunction(response);
      }
    },
    (error) => {
      if (failCallbackFunction) {
        failCallbackFunction(error);
      }
    },
  );
};

service.updateWidgetPrivacyMode = (
  widgetId,
  widgetPrivacyMode,
  successCallbackFunction,
  failCallbackFunction,
) => {
  const requestObj = {
    widgetId,
    newWidgetPrivacyMode: widgetPrivacyMode,
    token: storageService.getItem('token'),
  };
  WidgetRestService.update(
    {
      endpoint: 'privacy',
      endpointParam: widgetId,
    },
    requestObj,
    (response) => {
      if (successCallbackFunction) {
        successCallbackFunction(response);
      }
    },
    (error) => {
      if (failCallbackFunction) {
        failCallbackFunction(error);
      }
    },
  );
};

service.addWidgetAdmins = (
  widgetId,
  widgetAdminDtos,
  successCallbackFunction,
  failCallbackFunction,
) => {
  const requestObj = {
    widgetId,
    widgetAdminDtos,
    token: storageService.getItem('token'),
  };
  WidgetRestService.update(
    {
      endpoint: 'admins',
      endpointParam: widgetId,
    },
    requestObj,
    (response) => {
      if (successCallbackFunction) {
        successCallbackFunction(response);
      }
    },
    (error) => {
      if (failCallbackFunction) {
        failCallbackFunction(error);
      }
    },
  );
};

service.deleteWidgetAdmin = (
  widgetId,
  mentorOwnerId,
  successCallbackFunction,
  failCallbackFunction,
) => {
  const requestObj = {
    endpoint: 'admins/delete',
    endpointParam: widgetId,
    endpoint2: 'objectId',
    endpointParam2: mentorOwnerId,
    token: storageService.getItem('token'),
  };
  WidgetRestService.delete(
    requestObj,
    requestObj,
    (response) => {
      if (successCallbackFunction) {
        successCallbackFunction(response);
      }
    },
    (error) => {
      if (failCallbackFunction) {
        failCallbackFunction(error);
      }
    },
  );
};

service.activateWidgetByWidgetId = (
  widgetId,
  successCallbackFunction,
  failCallbackFunction,
) => {
  const requestObj = {
    token: storageService.getItem('token'),
  };
  WidgetRestService.update(
    {
      endpoint: 'activate/widgetId',
      endpointParam: widgetId,
    },
    requestObj,
    (response) => {
      if (successCallbackFunction) {
        successCallbackFunction(response);
      }
    },
    (error) => {
      if (failCallbackFunction) {
        failCallbackFunction(error);
      }
    },
  );
};

service.deActivateWidgetByWidgetId = (
  widgetId,
  successCallbackFunction,
  failCallbackFunction,
) => {
  const requestObj = {
    token: storageService.getItem('token'),
  };
  WidgetRestService.update(
    {
      endpoint: 'deactivate/widgetId',
      endpointParam: widgetId,
    },
    requestObj,
    (response) => {
      if (successCallbackFunction) {
        successCallbackFunction(response);
      }
    },
    (error) => {
      if (failCallbackFunction) {
        failCallbackFunction(error);
      }
    },
  );
};

service.deleteWidgetByWidgetId = (
  widgetId,
  successCallbackFunction,
  failCallbackFunction,
) => {
  const token = storageService.getItem('token');
  WidgetRestService.delete(
    {
      endpoint: 'widgetId',
      endpointParam: widgetId,
      token,
    },
    {
      token,
    },
    (response) => {
      if (successCallbackFunction) {
        successCallbackFunction(response);
      }
    },
    (error) => {
      if (failCallbackFunction) {
        failCallbackFunction(error);
      }
    },
  );
};

service.activateMentorByWidgetAndMentorId = (
  widgetId,
  mentorId,
  successCallbackFunction,
  failCallbackFunction,
) => {
  const requestObj = {
    token: storageService.getItem('token'),
  };
  WidgetRestService.update(
    {
      endpoint: 'activate/widgetId',
      endpointParam: widgetId,
      endpoint2: 'mentorId',
      endpointParam2: mentorId,
    },
    requestObj,
    (response) => {
      if (successCallbackFunction) {
        successCallbackFunction(response);
      }
    },
    (error) => {
      if (failCallbackFunction) {
        failCallbackFunction(error);
      }
    },
  );
};

service.deActivateMentorByWidgetAndMentorId = (
  widgetId,
  mentorId,
  successCallbackFunction,
  failCallbackFunction,
) => {
  const requestObj = {
    token: storageService.getItem('token'),
  };
  WidgetRestService.update(
    {
      endpoint: 'deactivate/widgetId',
      endpointParam: widgetId,
      endpoint2: 'mentorId',
      endpointParam2: mentorId,
    },
    requestObj,
    (response) => {
      if (successCallbackFunction) {
        successCallbackFunction(response);
      }
    },
    (error) => {
      if (failCallbackFunction) {
        failCallbackFunction(error);
      }
    },
  );
};

service.deleteMentorFromWidget = (
  widgetId,
  mentorId,
  successCallbackFunction,
  failCallbackFunction,
) => {
  const token = storageService.getItem('token');
  WidgetRestService.delete(
    {
      endpoint: 'widgetId',
      endpointParam: widgetId,
      endpoint2: 'mentorId',
      endpointParam2: mentorId,
      token,
    },
    {
      token,
    },
    (response) => {
      if (successCallbackFunction) {
        successCallbackFunction(response);
      }
    },
    (error) => {
      if (failCallbackFunction) {
        failCallbackFunction(error);
      }
    },
  );
};

const widgetService = {...service};
export default widgetService;
